import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@app-env';
import { catchError, lastValueFrom, of } from 'rxjs';
import { LoggingService } from './logging.service';

export const ENDPOINTS_CONFIG = {
    states: `${environment.DewarClaimsRespondentREST}/states`,
    countries: `${environment.DewarClaimsRespondentREST}/countries`,
};

@Injectable({
    providedIn: 'root',
})
export class AppConfigService {
    lookupData: { [key: string]: any } = [];

    constructor(private readonly http: HttpClient) {}

    loadLookupData(): Promise<void> {
        const endpoints = [ENDPOINTS_CONFIG.states, ENDPOINTS_CONFIG.countries];
        const requests = endpoints.map((endpoint) =>
            lastValueFrom(
                this.http.get(endpoint).pipe(
                    catchError((error) => {
                        LoggingService.log(`Failed to load data from ${endpoint}:`, error);
                        return of(null); // Return a fallback value
                    }),
                ),
            ),
        );

        return Promise.all(requests).then((responses) => {
            endpoints.forEach((endpoint, index) => {
                this.lookupData[endpoint] = responses[index];
                LoggingService.log('AppConfigService.loadLookupData() data:', this.lookupData[endpoint]);
            });
            return Promise.resolve();
        });
    }

    getLookupData(endpoint: string): any {
        return this.lookupData[endpoint];
    }
}
